import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';
import { Build, Code, Speed, LocalGasStation } from '@mui/icons-material';
import { siteConfig } from '../config/siteConfig';

const Services = () => {
  const icons = [Build, Code, Speed, LocalGasStation];

  return (
    <Box sx={{ py: 8, bgcolor: siteConfig.colors.lightGray }}>
      <Container maxWidth="lg">
        <Typography variant="h3" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 6, color: siteConfig.colors.secondary }}>
          Wir bieten professionelle Leistungsoptimierung für alle Fahrzeugtypen
        </Typography>

        <Grid container spacing={4}>
          {siteConfig.services.map((service, index) => {
            const Icon = icons[index];
            return (
              <Grid item xs={12} sm={6} md={3} key={service.title}>
                <Card sx={{ height: '100%', textAlign: 'center', transition: 'transform 0.3s', '&:hover': { transform: 'translateY(-10px)' } }}>
                  <CardContent sx={{ p: 4 }}>
                    <Icon sx={{ fontSize: 60, color: siteConfig.colors.primary, mb: 2 }} />
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: siteConfig.colors.secondary }}>
                      {service.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: siteConfig.colors.text }}>
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>

        {/* Additional Features */}
        <Grid container spacing={3} sx={{ mt: 6 }}>
          <Grid item xs={12} md={6}>
            <Box sx={{ p: 3, bgcolor: 'white', borderRadius: 2, borderLeft: `4px solid ${siteConfig.colors.primary}` }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                2 Jahre Garantie
              </Typography>
              <Typography variant="body2">
                Wir stehen hinter unserer Arbeit und bieten Ihnen eine umfassende 2-Jahres-Garantie auf alle unsere Chiptuning-Leistungen.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ p: 3, bgcolor: 'white', borderRadius: 2, borderLeft: `4px solid ${siteConfig.colors.primary}` }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                Schnelle Bearbeitung
              </Typography>
              <Typography variant="body2">
                In der Regel ist Ihr Fahrzeug innerhalb von nur 1-2 Stunden fertig optimiert und bereit für die Straße.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;
